import { render } from "./Gift.vue?vue&type=template&id=9eac387e&ts=true"
import script from "./Gift.vue?vue&type=script&lang=ts"
export * from "./Gift.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__